import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export interface LoaderProps {
    loading: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ loading }) => {
    return (
        <>
            {!!loading && (
                <Box
                    sx={{ display: 'flex' }}
                    zIndex={99999}
                    position='absolute'
                    top='50%'
                    left='50%'
                    marginTop={-12}
                    marginLeft={-12}
                >
                    <CircularProgress size={24} />
                </Box>
            )}
        </>
    );
};
